module.exports = __webpack_public_path__ + "static/media/pie-izquierdo.bc1a3f85.svg";